export default __webpack_public_path__ + "static/media/my-profile.dbd12a87.svg";